import React from "react";
import OfficialMatchDetailContent from "@/components/protocol/OfficialMatchDetailContent";

export default function ProtocolOfficialMatchView({ officialId, onBack, onStartProtocol }) {
  return (
    <OfficialMatchDetailContent
      officialId={officialId}
      embedded
      onBack={onBack}
      onStartProtocol={onStartProtocol}
      showTutorial
    />
  );
}
